/**
 * Given a collection of items with `ids`, orders by id and serializes ID; this
 * can be used to compare collections in an extremely shallow fashion.
 */
const simpleSerializeCollection = (coll = []) =>
	coll.map((item) => item["id"]).sort().join(",")
;

export {simpleSerializeCollection};
